site.fileupload = {
	init: function (element) {
		var $file = $(element);
		if ($file.length) {
			$(document).on('change', $file, function() {
				var filename = $file.val().replace(/C:\\fakepath\\/i, '');
				if (filename.length > 0) {
					$file.closest('span').attr('data-filename', filename.length > 20
						? filename.substr(0, 12) + '...' + filename.substr(filename.length - 12, filename.length)
						: filename);
				}
				else {
					$file.closest('span').removeAttr('data-filename');
				}
			});
		}
	}
};
